import { Button } from "./ui/button";
import { EnrollmentModal } from "./EnrollmentModal";
import { ArrowRight, Phone, Mail } from 'lucide-react';
import { useState } from 'react';

export function CTA() {
  const [isEnrollmentModalOpen, setIsEnrollmentModalOpen] = useState(false);
  return (
    <section className="py-20 bg-gradient-to-r from-orange-400 via-pink-400 to-purple-500">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Ready to Start Your Child's Learning Journey?
          </h2>
          <p className="text-xl mb-8 opacity-90 leading-relaxed">
            Join hundreds of families who trust us with their child's education. 
            Schedule a visit today and see the difference our programs can make.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button 
              className="bg-white text-orange-500 hover:bg-gray-100 px-8 py-4 rounded-full text-lg font-medium inline-flex items-center"
              onClick={() => setIsEnrollmentModalOpen(true)}
            >
              Schedule a Visit
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button variant="outline" className="border-2 border-white text-orange-500 hover:bg-white hover:text-orange-500 px-8 py-4 rounded-full text-lg font-medium">
              Download Brochure
            </Button>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-8 justify-center items-center text-lg">
            <div className="flex items-center">
              <Phone className="w-6 h-6 mr-3" />
              <span>(519) 472-4499</span>
            </div>
            <div className="flex items-center">
              <Mail className="w-6 h-6 mr-3" />
              <span>info@eyeslkmontesorri.ca</span>
            </div>
          </div>
        </div>
        
        {/* Decorative elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full"></div>
          <div className="absolute bottom-10 right-10 w-32 h-32 bg-white/5 rounded-full"></div>
          <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-white/8 rounded-full"></div>
        </div>
      </div>
      
      <EnrollmentModal 
        isOpen={isEnrollmentModalOpen} 
        onClose={() => setIsEnrollmentModalOpen(false)} 
      />
    </section>
  );
}